type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  body?: string;
  center?: boolean;
};

export function SectionHeading({
  eyebrow,
  title,
  body,
  center = false,
}: SectionHeadingProps) {
  return (
    <div className={center ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
      <p className="section-eyebrow">{eyebrow}</p>
      <h2 className="section-title">{title}</h2>
      {body ? <p className="section-copy">{body}</p> : null}
    </div>
  );
}
